import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BaseModal from 'components/BaseModal';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function ThanksModal({ open, onClose }) {
  return (
    <BaseModal
      open={open}
      size="sm"
      icon="/images/checkmark-filled.svg"
      title={<b>Thank you very much for your review</b>}
      content={
        <Box px={2}>
          <Typography>
            We appreciate your feedback. We will review it to make sure everything is ok before
            posting it to the wall.
          </Typography>
        </Box>
      }
      actionText="Proceed"
      cancelButton={false}
      onActionClick={onClose}
      onClose={onClose}
    />
  );
}

ThanksModal.propTypes = Props;
